/**
 * "Als Standard merken" je (Channel, Texttyp) — persistiert das Feld-Rezept
 * beim Verlassen von Schritt 2 (Spec 2026-07-24 §2).
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { upsertFieldRecipe } from '@/lib/api/channel-content-field-recipes'

import { fieldRecipesQueryKey } from './useFieldRecipes'

export function useFieldRecipeMutations() {
  const qc = useQueryClient()

  return {
    upsert: useMutation({
      mutationFn: upsertFieldRecipe,
      onSuccess: () => qc.invalidateQueries({ queryKey: fieldRecipesQueryKey }),
    }),
  }
}
